import React from 'react';
import { FooterWrapper } from './styled';
import moment from 'moment';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <FooterWrapper className="mt-10">
      <div>
        <span className="text-muted">{moment().format('YYYY')}©</span>{' '}
        <span className="text-dark">TechProfit Team</span>
      </div>
      <ul className="menu-wrapper">
        <li className="menu-item">
          <Link className="menu-link" to="/about">
            About
          </Link>
        </li>
        <li className="menu-item">
          <Link className="menu-link" to="/about">
            Support
          </Link>
        </li>
        {/* <li>
          <Link to="/about">About</Link>
        </li> */}
      </ul>
    </FooterWrapper>
  );
}

export default Footer;
